import { Environment } from './Environment';
import { noop } from './noop';

export class ConsoleDev {
    private static _create(type: 'log' | 'error' | 'warn' | 'info') {
        if (Environment.IS_DEVELOPMENT) {
            // eslint-disable-next-line no-console
            return console[type].bind(null, '[ConsoleDev]: ');
        }

        return noop;
    }

    public static log = this._create('log');

    public static error = this._create('error');

    public static info = this._create('info');

    public static warn = this._create('warn');
}
